import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { logger } from '@sentry/react';
import { TrackingProvider } from 'modules/analytics';
import { initIntl, LocalizationProvider } from 'modules/i18n';
import { ThemeProvider } from 'modules/minimal-ui-theme';
import { ModalProvider } from 'modules/modal';
import { initSentry } from 'utils/sentry';
import { App } from './App';

void initIntl();
initSentry();

const queryClient = new QueryClient();

const handleControllerChange = () => {
  logger.warn(
    'New Service Worker has taken control. Reloading page to apply update and prevent mismatch errors.'
  );
  window.location.reload();
};

if ('serviceWorker' in navigator) {
  logger.info('Service Worker controllerchange listener initialized.');

  navigator.serviceWorker.addEventListener(
    'controllerchange',
    handleControllerChange
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LocalizationProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TrackingProvider>
            <ModalProvider>
              <App />
            </ModalProvider>
          </TrackingProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  </React.StrictMode>
);
